import object from '@mailobj-browser/front/js/utils/object.js'
import { hotkey } from './hotkey.js'

const handler = object(null, {
  task: async (
    element
  ) => {
    const { parentNode } = element
    parentNode.click()
  }
})

export default (
  element
) => {
  hotkey(element, handler)
}
